var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"tipsContent",class:_vm.extClass,attrs:{"id":"tipsContent"}},[_c('div',{staticClass:"tips",domProps:{"textContent":_vm._s(_vm.tips)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }